import { createAction } from "redux-actions";
import { Thunk } from "./Thunk";

import { NotificationConstants } from "../constants";
import { NotificationTarget, NotificationType } from "../models/notification";

export interface NotificationOptions {
    icon?: string;
    message: string;
    target?: NotificationTarget;
    type: NotificationType;
}

export interface NotificationAddPayload {
    icon?: string;
    message: string;
    newId: number;
    target?: NotificationTarget;
    timeout?: number;
    type: NotificationType;
}

export interface NotificationKillTimerPayload {
    notificationId: number;
    timeout?: number;
}

export type NotificationRemovePayload = number;

export const addNotification = (notificationOpts: NotificationOptions, timeout?: number): Thunk => (dispatch, getState) => {
    const newId = getState().notifications.lastId + 1;
    dispatch(addNotificationAction({ ...notificationOpts, newId }));

    // kickoff timer to show notifications
    setTimeout(() => {
        dispatch(showNotificationAction(newId));
    }, 50);

    // kickoff notification kill timer
    dispatch(startNotificationKillTimer(newId, timeout));
};

export const notifyError = (message: string, icon?: string, timeout?: number): Thunk => (dispatch, getState) => {
    dispatch(addNotification({ icon, message, type: "danger" }, timeout));
};

export const notifyInfo = (message: string, icon?: string, timeout?: number): Thunk => (dispatch, getState) => {
    dispatch(addNotification({ icon, message, type: "info" }, timeout));
};

export const notifySuccess = (message: string, icon?: string, timeout?: number): Thunk => (dispatch, getState) => {
    dispatch(addNotification({ icon, message, type: "success" }, timeout));
};

export const notifyWarning = (message: string, icon?: string, timeout?: number): Thunk => (dispatch, getState) => {
    dispatch(addNotification({ icon, message, type: "warning" }, timeout));
};

export const addNotificationAction = createAction<NotificationAddPayload, NotificationAddPayload>(
    NotificationConstants.ADD, (result) => (result),
);

export const hideNotificationAction = createAction<number, number> (
    NotificationConstants.HIDE, (notificationId) => (notificationId),
);

export const removeNotificationAction = createAction<number, number> (
    NotificationConstants.REMOVE, (notificationId) => (notificationId),
);

export const showNotificationAction = createAction<number, number> (
    NotificationConstants.SHOW, (notificationId) => (notificationId),
);

export const startNotificationKillTimer = (notificationId: number, timeout?: number): Thunk => (dispatch, getState) => {
    setTimeout(() => {
        dispatch(hideNotificationAction(notificationId));
    }, timeout || 5000);
};



// WEBPACK FOOTER //
// ./src/actions/NotificationActions.ts